<template>
  <Takeover active>
    <CheckoutHeader />
    <div class="existing">
      <ScreenHeading><span v-html="heading"></span></ScreenHeading>
      <p>
        If you'd like to change your subscription, go to your <br />
        <AppLink :to="accountPath">Account page</AppLink> and cancel your current plan, then sign up for your preferred plan.
      </p>
      <p>Not {{ email }}? Click <AppLink :to="logoutPath">here</AppLink></p>
    </div>
  </Takeover>

  <div></div>
</template>

<script setup lang="ts">
import Takeover from '@/components/shared/Takeover.vue'
import CheckoutHeader from '@/components/shared/header/CheckoutHeader.vue'
import { useRoute } from 'vue-router'
import { storeToRefs } from 'pinia'
import { useUserStore } from '@/store/UserStore'
import { useProductStore } from '@/store/ProductStore'
import { useSubscriptionStore } from '@/store/SubscriptionStore'
import { useOfferStore } from '@/store/OfferStore'
import ScreenHeading from './ScreenHeading.vue'
import AppLink from '@/components/shared/AppLink.vue'
import { computed } from 'vue'
import { ProductId } from '@/types'
const route = useRoute()
const { query, params } = route

const userStore = useUserStore()
const { email } = storeToRefs(userStore)

const productStore = useProductStore()
const { name } = storeToRefs(productStore)

const subscriptionStore = useSubscriptionStore()
const { mostRecentSubscriptionProduct } = storeToRefs(subscriptionStore)

const offerStore = useOfferStore()
const { promotionalOfferProduct } = storeToRefs(offerStore)

const accountPath = import.meta.env.VITE_OUTPUT_ACCOUNTS_HOSTNAME

const hasOutputOnePlan = computed(
  () => mostRecentSubscriptionProduct.value === ProductId.OutputOne || promotionalOfferProduct.value.includes(ProductId.OutputOne)
)

const heading = computed(() =>
  hasOutputOnePlan.value
    ? 'You already have access to<br/> Arcade, Co-Producer, and Output FX<br /> as part of Output One.'
    : `You already have a subscription that includes<br /> ${name.value}.`
)

const logoutPath = computed(() => ({
  name: 'logout',
  query,
  params
}))
</script>

<style lang="scss" scoped>
.existing {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  text-align: center;
  width: 100%;
  margin: $spacer-5 0;

  @include media-breakpoint(md) {
    margin: $spacer-9 0 $spacer-5;
  }
}
</style>
